export interface SheetStatistic {
  examineeCount: number;
  schoolCount: number;
  isConfigured: boolean;
}

export interface ExamineeImport {
  examineeCount: number;
  schoolCount: number;
  importId?: string;
  importStatus?: boolean;
}

export enum SystemId {
  Custom,
  Sioepkz,
  Sioeo,
}

export enum ImportExamineeStatus {
  WrongFileExtension,
  EmptyOrWrongFileContent,
  Failed,
  Success,
}
